import { Helmet } from "react-helmet";
import React from "react";
import Banner from "../Components/Banner";
import Lottery from "../Components/Lottery";
import LotteryDisplay from "../Components/LotteryDisplay";
import Plans from "../Components/Plans";
import ContactInfo from "../Components/ContactInfo.jsx";
import ContactInfoForm from "../Components/ContactInfoForm";
import Footer from "../Components/Footer";
import AppDownload from "../Components/AppDownload";
import Services from "../Components/Services";
import "../styles/main.css";
import Testimonials from "../Components/Testimonials";

export default function Landing() {
	return (
		<div style={{ background: "white", color: "black", overflowX: "hidden", width: "100%" }}>
			<Helmet>
				<title>BeyondLottery</title>
				<meta name='description' content='Beyond Lottery app' />
				<link rel='icon' href='/favicon.png' />
			</Helmet>

			<main>
				<Banner />
				<Lottery />
				<LotteryDisplay />
				<Plans />
				<Services />
				<Testimonials />
				<ContactInfo />
				<ContactInfoForm />
				<AppDownload />
				<Footer />
			</main>
		</div>
	);
}
